function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { dailyRecordsShape } from 'shapes/bins';
import App from 'modules/App';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import messages from 'modules/AmbulatoryGlucoseProfile/messages';
import BloodGlucoseProfileReportAgpMiniChart from 'components/Charts/BloodGlucoseProfileAgpMiniChart/BloodGlucoseProfileReportAgpMiniChart';
import SectionTitle from '../components/SectionTitle';
import styles from './DailyGlucoseProfileSection.pcss';
var _React_Component;
class DailyGlucoseProfilesSection extends (_React_Component = React.Component) {
    renderChart(dailyRecords) {
        const { conversion, standards, direction, maxValue } = this.props;
        return /*#__PURE__*/ _jsx(BloodGlucoseProfileReportAgpMiniChart, {
            conversion: conversion,
            standards: standards,
            records: dailyRecords.records,
            direction: direction,
            maxValue: maxValue
        });
    }
    renderDay() {
        const { dailyRecordsTopTwoWeeks } = this.props;
        const firstWeek = dailyRecordsTopTwoWeeks.slice(0, 7);
        const firstWeekWeekdays = firstWeek.map(({ weekday })=>weekday);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.weekdays,
                    children: firstWeekWeekdays.map((weekday)=>/*#__PURE__*/ _jsx("div", {
                            className: styles.weekday,
                            children: weekday
                        }, weekday))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.day,
                    children: dailyRecordsTopTwoWeeks.map((dailyRecord, i)=>{
                        const isFirstRow = i < 7;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: cn(styles.day__cell, {
                                [styles['day__cell--firstRow']]: isFirstRow
                            }),
                            role: "presentation",
                            children: [
                                this.renderChart(dailyRecord),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.day__cellDayNumber,
                                    children: Number(dailyRecord.date.split('-')[2]) || ''
                                }),
                                isFirstRow && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        i === 0 && /*#__PURE__*/ _jsx("div", {
                                            className: cn(styles.day__cellHour, styles['day__cellHour--start']),
                                            children: moment('00', 'hh').format('LT').toString().replaceAll(':00', '')
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: cn(styles.day__cellHour, styles['day__cellHour--middle']),
                                            children: moment('12', 'hh').format('LT').toString().replaceAll(':00', '')
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: cn(styles.day__cellHour, styles['day__cellHour--end'], {
                                                [styles['day__cellHour--last']]: i === 6
                                            }),
                                            children: moment('00', 'hh').format('LT').toString().replaceAll(':00', '')
                                        })
                                    ]
                                })
                            ]
                        }, dailyRecord.date);
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.dailyGlucoseProfilesSectionWrapper,
            children: [
                /*#__PURE__*/ _jsx(SectionTitle, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.dailyGlucoseProfiles))
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.profileAnnotation,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.dailyBgmGlucoseProfilesAnnotation))
                }),
                this.renderDay()
            ]
        });
    }
}
_define_property(DailyGlucoseProfilesSection, "propTypes", {
    // Implicit props
    dailyRecordsTopTwoWeeks: dailyRecordsShape,
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    direction: PropTypes.string,
    maxValue: PropTypes.number
});
const mapStateToProps = (state)=>({
        dailyRecordsTopTwoWeeks: AmbulatoryGlucoseProfile.selectors.dailyRecordsTopTwoWeeks(state),
        direction: App.selectors.direction(state)
    });
const ConnectedDailyGlucoseProfilesSection = connect(mapStateToProps)(DailyGlucoseProfilesSection);
export default withStyles(styles)(ConnectedDailyGlucoseProfilesSection);
